import { MDSText } from '@midwest/web/base';
import * as RadixAccordion from '@radix-ui/react-accordion';
import styled from 'styled-components';

export const AccordionRoot = styled(RadixAccordion.Root)`
  width: 100%;
`;

export const AccordionHeader = styled(RadixAccordion.Header)`
  width: 100%;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
`;

export const AccordionTrigger = styled(RadixAccordion.Trigger)`
  width: 100%;
  background: transparent;
  border: none;
  padding: 0;
  &[data-state='open'] svg {
    transform: rotate(180deg);
  }
  &[data-state='closed'] svg {
    transform: rotate(90deg);
  }
`;

export const AccordionItem = styled(RadixAccordion.Item)`
  width: 100%;
  border-bottom: 1px solid #f9eedb;
`;

export const AccordionContent = styled(RadixAccordion.Content)``;

export const AccordionHeaderContent = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const AccordionTitleText = styled(MDSText.Subtitle)`
  font-weight: 700;
  font-size: 1rem;
  color: ${(p) =>
    p.theme.midwestColors.componentButtonColorBackgroundStrongPrimaryDefault};
`;
